

import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Gowri.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import axios from 'axios';
import city from '../../../city.json'





const Gowri = () => {

  const tooltips = {
  "Laabam - Gain": "Laabam means profit or gain — a good time to start work related to success or advantage.",
  "Dhanam - Wealth": "Dhanam indicates prosperity and wealth — favorable for financial beginnings.",
  "Sugam - Good": "Sugam suggests comfort and ease — suitable for general positive outcomes.",
  "Uthi - Good": "Uthi signifies rising or improving time — good for progressing tasks.",
  "Amirdha - Best": "Amirdha is the most auspicious — best for any important or sacred work.",
  "Rogam - Evil": "Rogam means illness or negativity — avoid starting anything important.",
  "Soram - Bad": "Soram is linked with confusion or disorder — not good for planning or new starts.",
  "Visham - Bad": "Visham represents toxicity or difficulty — inauspicious for new ventures.",
};


  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("New Delhi, India");
  const [dayMuhurta, setDayMuhurta] = useState([]);
  const [nightMuhurta, setNightMuhurta] = useState([]);
  const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"


    // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);
const [selectedTile, setSelectedTile] = useState(null);
const handleTileClick = (item, period) => {
  setSelectedTile({
    type: item.type,
    status: item.status,
    time: item.time,
    period, // Day / Night
    date: readableDate,
    weekday: weekDay,
    location,
    description: tooltips[item.type] || "No description available",
  });
};


  useEffect(() => {
    const fetchGowriData = async () => {
      const formattedDate = currentDate.toISOString().split('T')[0];

      if (!location || location.trim() === '') return;

      const getStatus = (type) => {
        const goodTypes = ['"Laabam - Gain', 'Dhanam - Wealth', 'Sugam - Good', 'Uthi - Good', 'Amirdha - Best'];
        return goodTypes.includes(type) ? 'good' : 'bad';
      };



      try {
        const response = await axios.get(
          `https://core-c343.onrender.com/api/gowri?date=${formattedDate}&location=${encodeURIComponent(location)}`
        );

         const data = response.data;


         setDayMuhurta(
          data.gowriPanchangam.dayMuhurtham.map(item => ({
            type: item.type,
            status: getStatus(item.type),
            time: `${item.start} to ${item.end}`,
          }))
        );

         setNightMuhurta(
          data.gowriPanchangam.nightMuhurtham.map(item => ({
            type: item.type,
            status: getStatus(item.type),
            time: `${item.start} to ${item.end}`,
          }))
        );


        
      } catch (err) {
        console.error('Failed to fetch Gowri Panchangam:', err);
      }
    };

    const debounce = setTimeout(fetchGowriData, 500);
    return () => clearTimeout(debounce);

  }, [currentDate, location]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

const formatTime = (time, mode) => {
  if (!time || typeof time !== 'string') return "N/A";

  const [start, end] = time.split(" to ");

  const parseTime = (t) => {
    if (!t) return "N/A";
    const [hourMin, ampm] = t.trim().split(' ');
    let [hour, minute] = hourMin.split(':').map(Number);
    const isPM = ampm?.toLowerCase() === 'pm';

    if (mode === '12') {
      const suffix = isPM ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}`;
    }

    if (mode === '24') {
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    }

    if (mode === '24Plus') {
      if (isPM && hour < 12) hour += 12;
      if (!isPM && hour === 12) hour = 0;
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    }

    return t;
  };

  return `${parseTime(start)} to ${parseTime(end)}`;
};

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

const parseTimeToDate = (timeStr, referenceDate) => {
  if (!timeStr) return null;
  const [time, meridiem] = timeStr.trim().split(' ');
  let [hours, minutes] = time.split(':').map(Number);
  if (meridiem.toLowerCase() === 'pm' && hours < 12) hours += 12;
  if (meridiem.toLowerCase() === 'am' && hours === 12) hours = 0;

  const date = new Date(referenceDate);
  date.setHours(hours, minutes, 0, 0);
  return date;
};

const findCurrentMuhurta = (muhurtaList) => {
  const now = new Date();
  for (let muhurta of muhurtaList) {
    const [startStr, endStr] = muhurta.time.split(' to ');
    const startTime = parseTimeToDate(startStr, now);
    const endTime = parseTimeToDate(endStr, now);
    if (startTime && endTime && now >= startTime && now <= endTime) {
      return muhurta;
    }
  }
  return null; // no active muhurta found
};



const currentDayMuhurta = findCurrentMuhurta(dayMuhurta);
const currentNightMuhurta = findCurrentMuhurta(nightMuhurta);


if (selectedTile) {
  return (
    <div className="Gowri-container">
      <InnerNav />

      <div className="Gowri-content">
        <button
          onClick={() => setSelectedTile(null)}
          style={{
            padding: "8px 14px",
            background: "#b35c00",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            width: "fit-content",
            marginBottom: "1rem"
          }}
        >
          ← Back
        </button>

        <div className="Gowri-details">
          <h2>{selectedTile.type} Gowri Panchangam</h2>

          <p style={{ fontSize: "1.05rem", marginBottom: "1rem" }}>
            This is a <b>{selectedTile.status === "good" ? "favorable" : "non-favorable"}</b> Gowri period
            occurring during the <b>{selectedTile.period.toLowerCase()}</b>.
          </p>

          <hr />

          <p>
            🕒 <b>Time Period</b><br />
            {formatTime(selectedTile.time, timeFormat)}
          </p>

          <p>
            📅 <b>Date</b><br />
            {selectedTile.date} ({selectedTile.weekday})
          </p>

          <p>
            📍 <b>Location</b><br />
            {selectedTile.location}
          </p>

          <hr />

          <p>
            🧿 <b>What does this mean?</b><br />
            {selectedTile.description}
          </p>

          <p style={{ marginTop: "1rem", fontStyle: "italic", color: "#555" }}>
            Tip: Gowri Panchangam results are traditionally used for selecting
            Nalla Neram in Tamil astrology.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

  

  return (
    <div className="Gowri-container">
      <InnerNav />
      <div className="Gowri-content">
        <Zodiac />
        <div className="Gowri-details">
                <div className="title">Gouri Panchagam Muhurat Table</div>
                {/* <div className="sub">Running Do Ghati Muhurat</div> */}
              <div className="header">
                <div className="img-details">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
                  <div className="right">
                      <div>
                        <h3>Current Active Day Muhurta:</h3>
                        {currentDayMuhurta ? (
                          <p>{currentDayMuhurta.status} ({formatTime(currentDayMuhurta.time, timeFormat)})</p>
                        ) : (
                          <p>No active day muhurta now</p>
                        )}

                        <h3>Current Active Night Muhurta:</h3>
                        {currentNightMuhurta ? (
                          <p>{currentNightMuhurta.status} ({formatTime(currentNightMuhurta.time, timeFormat)})</p>
                        ) : (
                          <p>No active night muhurta now</p>
                        )}
                      </div>

                  </div>
                </div>
                <div className="date-display">
                  <span className="day">{currentDate.getDate()}</span>
                  <span className="month">{readableDate}</span>
                </div>
              </div>

              <div className="controls">
                <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div>

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

              <div className="muhurta-section">
                <div className="muhurta-header">
                  <div className="muhurta-date">{readableDate}, {weekDay}</div>
                </div>


                  <div className="muhurta-columns">
                    {/* Day Gowri Panchangam */}
                    <div className="muhurta-column">
                      <span>🌞 Day Gouri Panchangam</span>
                      {dayMuhurta.map((item, idx) => (
                      <div
  key={idx}
  className={`muhurta-card ${item.status === 'good' ? 'green' : 'red'}`}
  onClick={() => handleTileClick(item, "Day")}
  style={{ cursor: "pointer" }}
>


                          {/* <div className="caerdds">
<div className="tooltip-wrapper">
  <div className="title">{item.type}</div>
  <span className="tooltip-text">{tooltips[item.type] || "No info available"}</span>
</div>
                        
                           </div> */}
                           <div className="caerdds">
  <div className="title">{item.type}</div>
</div>

                          <div className="time">
                            {formatTime(item.time, timeFormat)}
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Night Gowri Panchangam */}
                    <div className="muhurta-column">
                      <span>🌜Night Gouri Panchangam</span>
                      {nightMuhurta.map((item, idx) => (
                      <div
  key={idx}
  className={`muhurta-card ${item.status === 'good' ? 'green' : 'red'}`}
  onClick={() => handleTileClick(item, "Night")}
  style={{ cursor: "pointer" }}
>



                          {/* <div className="caerdds">
<div className="tooltip-wrapper">
  <div className="title">{item.type}</div>
  <span className="tooltip-text">{tooltips[item.type] || "No info available"}</span>
</div>
                          
                          </div> */}
                          <div className="caerdds">
  <div className="title">{item.type}</div>
</div>

                          <div className="time">
                            {formatTime(item.time, timeFormat)}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

              </div>
            </div>

      <section className="gowri-wrapper">
      <h1 className="gowri-title">About Tamil Gowri Panchangam Table</h1>
      <div className="gowri-texts">
        <p>
          Traditionally Tamil Gowri Panchangam is used for checking auspicious time to start new work and avoid inauspicious timings. Due to its simplicity, Gowri Panchangam can be used for any Muhurtham.
        </p>

        <p>
          All Gowri Panchangam timings, including Nalla Neram, are based on Gowri Panchangam table published in respected Pambu Panchangam in Tamil Nadu.
        </p>

        <h2>What is Nalla Neram?</h2>
        <p>
          Nalla Neram is a Tamil word. Neram (நேரம்) means Time and Nalla Neram (நல்ல நேரம்) means Good Time. Favourable time periods in Gowri Panchangam are known as Nalla Neram. Nalla Neram is the time that gives fruitful results and considered auspicious in Tamil astrology.
        </p>

        <h2>Auspicious and Inauspicious Timings</h2>
        <p>
          There are five good Gowri Panchangam timings, Amirdha, Dhanam, Uthi, Laabam and Sugam to start auspicious work.
        </p>

        <p>
          Three bad Gowri Panchangam timings, Rogam, Soram and Visham should be avoided.
        </p>
      </div>
    </section>

            
        <MuhuratLink/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Gowri;
